const prependNumber = (number) => {
    return (number < 10 ? '0' : '') + number;
};

const countdownToDate = (date) => {
    const now = new Date();
    const eventDate = new Date(date * 1000);
    const diff = eventDate - now;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    const done = diff < 0;

    return {
        done,
        days,
        hours,
        minutes,
        seconds,
    };
};

export default () => {
    // Elements
    const countdownBlock = document.querySelector('.wpg-wdp-product-countdown');
    const element = countdownBlock?.querySelector('.wpg-wdp-product-counter');
    const days = element?.querySelector('.wpg-wdp-product-counter-item-days .wpg-wdp-product-counter-item-value');
    const hours = element?.querySelector('.wpg-wdp-product-counter-item-hours .wpg-wdp-product-counter-item-value');
    const minutes = element?.querySelector('.wpg-wdp-product-counter-item-minutes .wpg-wdp-product-counter-item-value');
    const seconds = element?.querySelector('.wpg-wdp-product-counter-item-seconds .wpg-wdp-product-counter-item-value');

    // Attributes
    const dateAttribute = element?.getAttribute('data-countdown-date');

    if (!countdownBlock || !element || !days || !hours || !minutes || !seconds || !dateAttribute) {
        return;
    }

    const updateCountdown = setInterval(() => {
        const data = countdownToDate(dateAttribute);

        days.innerHTML = prependNumber(data.days) ?? '00';
        hours.innerHTML = prependNumber(data.hours) ?? '00';
        minutes.innerHTML = prependNumber(data.minutes) ?? '00';
        seconds.innerHTML = prependNumber(data.seconds) ?? '00';

        if (data.done) {
            clearInterval(updateCountdown);
            countdownBlock.remove();
        }
    }, 1000);
}
